import React, { useEffect, useState } from "react";
import TankLevel from "./tank_level.jsx";
import Table from "../../../components/table/table";
import { withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as styles from "../tanks.module.scss";
import * as FileSaver from 'file-saver';
import { utils } from "../../../utils/utils";
import { useHistory, useRouteMatch } from "react-router";
import tankService from "../../../services/tanksService.js";
import { createStructuredSelector } from "reselect";
import { selectTanksOperationsByTankId, selectTanksOperationsFilter } from "../../../state/selectors/tanks.js";
import { AccessLevel, AppModules } from "../../../constants/appAccess.js";
import ModuleAccess from "../../../components/access/module_access.jsx";

const Columns = [
    {
        header: "TankOperation.fuelType",
        name: "fuelType"
    },
    {
        header: "TankOperation.provider",
        name: "provider"
    },
    {
        header: "TankOperation.description",
        name: "description"
    },
    {
        header: "TankOperation.balance",
        name: "balance",
        dataType: "float"
    },
    {
        header: "TankOperation.deliveryDate",
        name: "deliveryDate",
        dataType: "datetime"
    },
    {
        header: "TankOperation.completed",
        name: "completed",
        dataType: "boolean"
    },
    {
        header: "TankOperation.userName",
        name: "userName",
        dataType: "text"
    }

];

const defaultFilter = (tankId) => {
    return {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: { tankId: tankId }
    }
}

const TankDetails = () => {
    const [tank, setTank] = useState(null);
    const [operations, setOperations] = useState([]);
    const [filter, setFilter] = useState(defaultFilter(0))

    const match = useRouteMatch();
    const history = useHistory();

    useEffect(() => {
        const tankId = parseInt(match.params.id);
        prepareData(tankId, defaultFilter(tankId));
    }, []);

    const prepareData = async (tankId, filter) => {
        const gt = getTank(tankId);
        const op = getOperations(filter);
        await gt;
        await op;
    }

    const getTank = async (tankId) => {
        const t = await tankService.getTankAsync(tankId);
        setTank(t);
    }

    const getReport = async () => {
        const report = await tankService.getOperationsReportAsync(filter);
        FileSaver.saveAs(report, 'tanks_operations.xlsx');
    }

    const getOperations = async (filter) => {
        // setState({ ...state, loading: true });

        const data = await tankService.getTankOperationsAsync(filter);
        setOperations(data.items);
        setFilter(data.filter);
    }

    const addTankOperation = () => {
        history.push('/tanks/' + tank.tankId + '/addtankoperation');
    }

    const editTank = () => {
        history.push('/tanks/edittank/' + tank.tankId);
    }

    const renderTank = () => {
        if (!tank) return <div></div>;
        return (
            <div className={[styles.tank_view_item, styles.tank_details_view_item].join(' ')}>
                <div>
                    <div className={styles.tank_header}>{tank.tankName}</div>
                    <TankLevel
                        minLevel={tank.minLevel}
                        maxLevel={tank.maxLevel}
                        level={tank.volume}
                        width="140"
                        height="200" />
                </div>
                <div className={styles.tank_details_info_container}>
                    <div className={styles.tank_details_info}>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.department</Trans><span>: </span><span>{tank.department}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.fuelType</Trans><span>: </span><span>{tank.fuelType}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.Details.maxLevel</Trans><span>:</span></div>
                            <div>{tank.maxLevel}</div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>Tanks.Details.calculatedVolume</Trans><span>:</span></div>
                            <div>{tank.volume && tank.volume.toFixed(2)}</div>
                        </div>
                    </div>
                    {tank.lastLevelsState && <div className={styles.tank_details_info}>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.watterLevelHeight</Trans><span>: </span><span>{tank.lastLevelsState.watterLevelHeight}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.watterLevelVolume</Trans><span>: </span><span>{tank.lastLevelsState.watterLevelVolume}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.productLevelHeight</Trans><span>: </span><span>{tank.lastLevelsState.productLevelHeight}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.productLevelVolume</Trans><span>: </span><span>{tank.lastLevelsState.productLevelVolume}</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.temperature</Trans><span>: </span><span>{tank.lastLevelsState.temperature}</span><span>&#730;C</span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.density</Trans><span>: </span><span>{tank.lastLevelsState.density}</span><span><Trans>TankStateOperation.densityUnit</Trans></span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.weight</Trans><span>: </span><span>{tank.lastLevelsState.weight}</span><span><Trans>TankStateOperation.weightUnit</Trans></span></div>
                        </div>
                        <div className={styles.tank_info_line}>
                            <div><Trans>TankStateOperation.packageTs</Trans><span>: </span><span>{utils.formatDate(new Date(tank.lastLevelsState.packageTs.split('.')[0] + ".000Z"))}</span></div>
                        </div>
                    </div>}
                    <div className={styles.edit_tank_buttons_container}>
                        <ModuleAccess moduleName={AppModules.TankOperations} access={AccessLevel.Write} >
                            <button className={styles.add_operation_button} onClick={addTankOperation}></button>
                        </ModuleAccess>
                        <ModuleAccess moduleName={AppModules.Tanks} access={AccessLevel.Write} >
                            <button className={styles.edit_tank_button} onClick={editTank}></button>
                        </ModuleAccess>
                    </div>


                </div>
            </div>
        );
    }

    const renderTankOperations = () => {
        return (
            <div>
                <Table settings={{
                    columns: Columns,
                    items: operations,
                    itemsFilter: filter,
                    isEditable: false,
                    getItemsFunction: getOperations,
                    getReportFunction: getReport
                }} />
            </div>
        );
    }

    return (
        <div className={styles.tank_details_container}>
            <div>
                {
                    renderTank()
                }
            </div>
            <div>
                {
                    renderTankOperations()
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    const tankId = parseInt(ownProps.match.params.id);
    return createStructuredSelector({
        operations: selectTanksOperationsByTankId(tankId),
        filter: selectTanksOperationsFilter()
    });
}

export default withRouter(connect(mapStateToProps)(withTranslation('translantions')(TankDetails)));